var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('h1',{staticClass:"officehome-gnb-hiworks"},[_c('a',{attrs:{"href":_vm.logoPath,"title":_vm.$t('오피스')}},[(_vm.viewType === 'mobile')?_c('ShortHiworksLogo'):_c('HiworksLogo')],1)])}
var staticRenderFns = []

export { render, staticRenderFns }